"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconeDeFechar = exports.Conteudo = exports.Container = exports.Sobreposicao = void 0;
var React = __importStar(require("react"));
var rebass_1 = require("rebass");
var react_feather_1 = require("react-feather");
var tema_1 = require("../../tema");
var classnames_1 = __importDefault(require("classnames"));
var ModalLayers;
(function (ModalLayers) {
  ModalLayers[ModalLayers["Top"] = 1002] = "Top";
  ModalLayers[ModalLayers["Overlay"] = 1001] = "Overlay";
})(ModalLayers || (ModalLayers = {}));
var Sobreposicao = function (props) {
  return React.createElement(rebass_1.Box, __assign({
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      backgroundColor: tema_1.colors.blue1,
      opacity: 0.9,
      zIndex: ModalLayers.Overlay
    }
  }, props));
};
exports.Sobreposicao = Sobreposicao;
var Container = function (props) {
  return React.createElement(rebass_1.Flex, __assign({
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "fixed",
      height: "100%",
      width: "100%",
      top: 0,
      left: 0,
      zIndex: ModalLayers.Top,
      borderRadius: 6
    }
  }, props));
};
exports.Container = Container;
var Conteudo = function (_a) {
  var sx = _a.sx,
    _b = _a.telaCheia,
    telaCheia = _b === void 0 ? false : _b,
    props = __rest(_a, ["sx", "telaCheia"]);
  return React.createElement(rebass_1.Box, __assign({
    className: classnames_1.default({
      telaCheia: telaCheia
    }),
    sx: __assign({
      backgroundColor: tema_1.colors.white,
      position: "relative",
      display: "flex",
      justifyContent: "space-between",
      zIndex: ModalLayers.Top,
      borderRadius: 5,
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      '&.telaCheia': {
        maxWidth: '100%',
        height: '100%',
        borderRadius: 0
      }
    }, sx)
  }, props));
};
exports.Conteudo = Conteudo;
var IconeDeFechar = function (_a) {
  var sx = _a.sx,
    props = __rest(_a, ["sx"]);
  return React.createElement(rebass_1.Flex, __assign({
    sx: __assign({
      position: "absolute",
      top: "12px",
      right: "17px",
      cursor: "pointer",
      color: tema_1.colors.blue4
    }, sx)
  }, props), React.createElement(react_feather_1.X, null));
};
exports.IconeDeFechar = IconeDeFechar;